import { FormInputProps } from 'brief-form'

import { BaseInputOpts } from '../props'

type IntegerInputOpts = BaseInputOpts & {
  formatted?: boolean
}

export interface IntegerInputProps extends FormInputProps<
  number | string | undefined | null | unknown,
  IntegerInputOpts
> {}
